export const STORAGE_KEY_USERS = 'STORAGE_KEY_USERS'

export const QUIZE_CHOICES_COUNT = 4

export const EMOTIONS = [
  { id: 1, emoji: '😀' },
  { id: 2, emoji: '😃' },
  { id: 3, emoji: '😄' },
  { id: 4, emoji: '😁' },
  { id: 5, emoji: '😆' },
  { id: 6, emoji: '😅' },
  { id: 7, emoji: '🤣' },
  { id: 8, emoji: '😂' },
  { id: 9, emoji: '🙂' },
  { id: 10, emoji: '🙃' },
  { id: 11, emoji: '😉' },
  { id: 12, emoji: '😊' },
  { id: 13, emoji: '😇' },
  { id: 14, emoji: '🥰' },
  { id: 15, emoji: '😍' },
  { id: 16, emoji: '🤩' },
  { id: 17, emoji: '😘' },
  { id: 18, emoji: '😗' },
  { id: 19, emoji: '😚' },
  { id: 20, emoji: '😙' },
  { id: 21, emoji: '😋' },
  { id: 22, emoji: '😛' },
  { id: 23, emoji: '😜' },
  { id: 24, emoji: '🤪' },
  { id: 25, emoji: '😝' },
  { id: 26, emoji: '🤑' },
  { id: 27, emoji: '🤗' },
  { id: 28, emoji: '🤭' },
  { id: 29, emoji: '🤫' },
  { id: 30, emoji: '🤔' },
  { id: 31, emoji: '🤐' },
  { id: 32, emoji: '🤨' },
  { id: 33, emoji: '😐' },
  { id: 34, emoji: '😑' },
  { id: 35, emoji: '😶' },
  { id: 36, emoji: '😏' },
  { id: 37, emoji: '😒' },
  { id: 38, emoji: '🙄' },
  { id: 39, emoji: '😬' },
  { id: 40, emoji: '🤥' },
  { id: 41, emoji: '😌' },
  { id: 42, emoji: '😔' },
  { id: 43, emoji: '😪' },
  { id: 44, emoji: '🤤' },
  { id: 45, emoji: '😴' },
  { id: 46, emoji: '😷' },
  { id: 47, emoji: '🤒' },
  { id: 48, emoji: '🤕' },
  { id: 49, emoji: '🤢' },
  { id: 50, emoji: '🤮' },
  { id: 51, emoji: '🤧' },
  { id: 52, emoji: '🥵' },
  { id: 53, emoji: '🥶' },
  { id: 54, emoji: '🥴' },
  { id: 55, emoji: '😵' },
  { id: 56, emoji: '🤯' },
  { id: 57, emoji: '🤠' },
  { id: 58, emoji: '🥳' },
  { id: 59, emoji: '😎' },
  { id: 60, emoji: '🤓' },
  { id: 61, emoji: '🧐' },
  { id: 62, emoji: '😕' },
  { id: 63, emoji: '😟' },
  { id: 64, emoji: '🙁' },
  { id: 65, emoji: '😮' },
  { id: 66, emoji: '😯' },
  { id: 67, emoji: '😲' },
  { id: 68, emoji: '😳' },
  { id: 69, emoji: '🥺' },
  { id: 70, emoji: '😦' },
  { id: 71, emoji: '😧' },
  { id: 72, emoji: '😨' },
  { id: 73, emoji: '😰' },
  { id: 74, emoji: '😥' },
  { id: 75, emoji: '😢' },
  { id: 76, emoji: '😭' },
  { id: 77, emoji: '😱' },
  { id: 78, emoji: '😖' },
  { id: 79, emoji: '😣' },
  { id: 80, emoji: '😞' },
  { id: 81, emoji: '😓' },
  { id: 82, emoji: '😩' },
  { id: 83, emoji: '😫' },
  { id: 84, emoji: '🥱' },
  { id: 85, emoji: '😤' },
  { id: 86, emoji: '😡' },
  { id: 87, emoji: '😠' },
  { id: 88, emoji: '🤬' }
]
